import React, { useState, useMemo } from "react";

import {
  AppBar,
  Box,
  Button,
  Toolbar,
  IconButton,
  Drawer,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  styled,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ArrowBack from "@mui/icons-material/ArrowBack";
import ExitIcon from "@mui/icons-material/ExitToApp";
import MenuIcon from "@mui/icons-material/Menu";
import ReceiptIcon from "@mui/icons-material/Receipt";

import { useNavigate, useLocation } from "react-router-dom";
// State
import { useSetRecoilState } from "recoil";

// Services
import StorageServices from "services/Storage";
import { modalWaterState } from "state/atoms";

const StyledDrawer = styled(Drawer)({
  "& .MuiDrawer-paper": {
    width: 200,
  },
});

const StyledButton = styled(Button)({
  color: "#fff",
  borderColor: "#fff",
});

const TemplateHeader = () => {
  const setModalState = useSetRecoilState(modalWaterState);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const canGoBack = location.pathname !== "/";

  function onOpen() {
    setDrawerOpen(true);
  }
  function onClose() {
    setDrawerOpen(false);
  }

  function onLogout() {
    StorageServices.removeUserToken();
    setDrawerOpen(false);
    navigate("/login");
  }

  function onGoReportsPage() {
    setDrawerOpen(false);
    navigate("/reports");
  }

  function onGoNewPage() {
    setDrawerOpen(false);
    navigate("/new");
  }

  const isDetailPage = useMemo(() => location.pathname.includes("/detail"), [location]);

  function onWater() {
    setModalState((p) => ({ ...p, open: true }));
  }

  return (
    <>
      <StyledDrawer anchor={"left"} onClose={onClose} open={drawerOpen}>
        <div role="presentation">
          <List>
            <ListItem button onClick={onGoNewPage}>
              <ListItemIcon>
                <AddIcon />
              </ListItemIcon>
              <ListItemText>Add new Tree</ListItemText>
            </ListItem>
            <ListItem button onClick={onGoReportsPage}>
              <ListItemIcon>
                <ReceiptIcon />
              </ListItemIcon>
              <ListItemText>Reports</ListItemText>
            </ListItem>
            <Divider />
            <ListItem button onClick={onLogout}>
              <ListItemIcon>
                <ExitIcon />
              </ListItemIcon>
              <ListItemText>Logout</ListItemText>
            </ListItem>
          </List>
        </div>
      </StyledDrawer>
      <AppBar position="static">
        <Toolbar>
          {canGoBack ? (
            <IconButton onClick={() => navigate(-1)} edge="start" color="inherit" aria-label="back">
              <ArrowBack />
            </IconButton>
          ) : (
            <IconButton onClick={onOpen} edge="start" color="inherit" aria-label="menu">
              <MenuIcon />
            </IconButton>
          )}
          {isDetailPage && (
            <Box ml="auto">
              <StyledButton onClick={onWater} variant="outlined">
                Water!
              </StyledButton>
            </Box>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
};

export default TemplateHeader;
